import * as actionType from "./actionTypes";
import { getRequestAuthed, processError, downloadFileAuthed } from "../../utils/apiHandlers";
import { LOADING_STATE, LS_ITEM_ADMIN } from "../../utils/stateTypes";
import _notif from "../notification";

export const loadSubscribers = () => (
  (dispatch) => {
    const lsItem = LS_ITEM_ADMIN.SUBSCRIBERS_LOAD;
    dispatch(_notif.actions.setLoadState(lsItem, LOADING_STATE.LOADING));

    getRequestAuthed("/AdminSubscriber/Subscribers",
      (subscribers) => {
        dispatch({ type: actionType.SET_SUBSCRIBERS, subscribers });
        dispatch(_notif.actions.setLoadState(lsItem, LOADING_STATE.LOADED));
      },
      processError(dispatch, _notif, lsItem),
    );
  }
);

export const exportCsv = () => (
  (dispatch) => {
    const lsItem = LS_ITEM_ADMIN.EXPORT;
    dispatch(_notif.actions.setLoadState(lsItem, LOADING_STATE.LOADING));

    downloadFileAuthed("/AdminSubscriber/ExportCsv", "cas-subscribers.csv")
      .then(() => dispatch(_notif.actions.setLoadState(lsItem, LOADING_STATE.LOADED)))
      .catch(processError(dispatch, _notif, lsItem));
  }
);
